import React, { useRef } from 'react'
import SectionHeader from '../components/SectionHeader'
import TabSection from '../components/TabSection';
import SocialProofSection from './SocialProofSection';

// Animations 
import useOnScreen from '../utility/useIntersection';
// TAB CONSTANTS
const TABS = {
    "data_science":"Data Science",
    "ai_ml":"A.I & M.L",
    "front_end":"Front-End",
    "general":"General",
    
}


export default function SkillsPage() {

    // Fade in animation
    const skillPageRef = useRef()
    const skillsIsVisible = useOnScreen(skillPageRef, "0px")

    const classNameString = skillsIsVisible?`perfect-page page skills-page container flex-between flex-align-center fade-in-section is-visible`:"perfect-page page skills-page container flex-between flex-align-center fade-in-section"

    return (
        <div ref={skillPageRef} className={classNameString} id="skills-page"> 
            <SectionHeader 
            sectionHeading = 'I - SKILLS'
            sectionNumber =  '1'
            alignment = 'section-number-align-end' 
            headerAlignment = 'align-end'
            />

            <TabSection 
            skillPageRef = {skillPageRef}
            />
            
            <SocialProofSection />


        </div>
    )
}
